/**
 * Компонента выбора индивидуала.
 * Для выбора индивидуала необходимо :
 * 1. Получение rdfType, которому должен соответствовать индивидуал
 * 2. Отображение диалога с выбором свойства и ввода данных этого свойтсв
 * 3. Вызов метода добавления свойства
 */
import React from 'react';
import { connect } from 'react-redux';
import { Form, Select, message } from 'antd';
import Label from '../widgets/Label';
import { LoadingComponent } from '../../utils/ui'
import { AdmsRepository, AdmsAsset, RdfTriplet } from '../../redux';
import { responseAsset } from '../../simbix/demo-response';


const formItemLayout = {
  labelCol  : { xs: { span: 24 }, sm: { span: 6 }, },
  wrapperCol: { xs: { span: 24 }, sm: { span: 18 }, },
};

const { Option } = Select;


/** Форма выбора индивидуала. Обязательно указать IRI выбранного индивидуала.
 * Для указания IRI можно либо ввести IRI либо выбрать из списка
 */
class SelectIndividualBasic extends React.Component {

  state = {
    loaded: false,                      //Флаг загрузки, списка элементов    
    limit: 100,                         //Лимит при загрузке элементов
    offset: 0,                          //Сдвиг при загрузке
    count: 0,                           //Количество элементов (всего)    
    EP:"2025",
    IRI: "http://www.w3.org/ns/adms#",
    predicat: "http://www.w3.org/2002/07/owl#NamedIndividual"
  };

  static getDerivedStateFromProps(props, state) {
    //console.log("SelectIndividual.js static getDerivedStateFromProps(props, state)", props, state);
    if ((state.IRI !=props.subject )||(state.predicat != props.predicat) || !props.subject){
      return {loaded: false};
    }
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    const {subject, predicat, factory, onLoadIndividual} = this.props;
    if (!this.state.loaded){
      onLoadIndividual(subject, predicat, factory)
        .then(result => { 
          //console.log(this, result);         
          const individuals = Array.isArray(result)? result:[];
          this.setState({loaded: true, IRI: subject, predicat, individuals});
        })
        .catch( e => {
          this.setState({loaded: true,  IRI: subject, predicat});
          console.log(e);
          message.error("Ошибка загрузки списка объектов.", e);
        })
    }
  }

  handleOnChange = value => {
    this.triggerChange({ value });
  };

  triggerChange = changedValue => {
    const { onChange, onSelected, value, IRI, predicat } = this.props;
    //console.log("SelectIndividual.js triggerChange", changedValue, IRI, predicat, value);
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
    onSelected(IRI, predicat, changedValue.value);
  };

  render() {
    console.log(this);
    const { IRI } = this.props;
    const {loaded, individuals} = this.state;
    return (
      (!loaded? <LoadingComponent />:
        <Form ref={this.props.formRef} {...formItemLayout} className="ant-edit-form">
          <Form.Item label="Связываемый элемент" extra={IRI}
            name="IRI"
            rules ={[{ required: true, message: 'Пожалуйста, выберите элемент!' }]}
          >
            <Select
              placeholder="IRI объекта для связи" 
              onChange={this.handleOnChange}>
              {individuals.map((item, key) => (
                <Option key={key} value={item}><Label iri={item}/> ({item})</Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      )
    );
  }
}


export const SelectUnLinkAssetForm = connect(
null,
dispatch => ({
  onLoadIndividual(subject, predicat, factory){
    return dispatch(AdmsRepository.loadUnLinkAssets())
      .then(response => {
        const {head, results} = response[0];
        const {distinct, ordered, bindings} = results;
        console.log("SelectIndividual.js SelectUnLinkAssetForm", bindings);
        return Promise.resolve(bindings.map(item => item.IRI.value));
      }).catch(e=>{
        return Promise.resolve([]);
      });
  },
  onSelected (subject, predicat, value){
    return dispatch(RdfTriplet.SELECTED(subject, IRI, predicat, value))
  }
})
)(SelectIndividualBasic);